module.exports = "data:image/gif;base64,R0lGODlhCgAKALMAANfX16Ojo////+Dg4Onp6ebm5tra2uXl5efn5+Li4gAAAAAAAAAAAAAAAAAAAAAAACH5BAAAAAAALAAAAAAKAAoAAAQfEMhJq70YC2H2oEIQhAFliIMICkNyFKB4IASVBgVBRAA7"


/*****************
 ** WEBPACK FOOTER
 ** ./extjs/resources/themes/images/gray/sizer/nw-handle.gif
 ** module id = 494
 ** module chunks = 0
 **/